import { cn } from '@pantry/ui';

type SyncStatus = 'synced' | 'diverged' | 'custom';

interface SyncBadgeProps {
  status: SyncStatus;
  className?: string;
}

const BADGE_CONFIG: Record<
  SyncStatus,
  { label: string; emoji: string; colorClass: string; bgClass: string }
> = {
  synced: {
    label: 'Synced',
    emoji: '🔗',
    colorClass: 'text-sync-active',
    bgClass: 'bg-sync-active/10',
  },
  diverged: {
    label: 'Edited',
    emoji: '✏️',
    colorClass: 'text-sync-diverged',
    bgClass: 'bg-sync-diverged/10',
  },
  custom: {
    label: 'Custom',
    emoji: '★',
    colorClass: 'text-sync-custom',
    bgClass: 'bg-sync-custom/10',
  },
};

/**
 * Badge showing a product group's sync status.
 */
export function SyncBadge({ status, className }: SyncBadgeProps) {
  const config = BADGE_CONFIG[status];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
        config.colorClass,
        config.bgClass,
        className
      )}
    >
      <span aria-hidden="true">{config.emoji}</span>
      {config.label}
    </span>
  );
}
